/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { lessonService } from '../../_services/lesson.service'
import Modal from 'react-responsive-modal'
// import PriceInput from '../Shared/PriceInput'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { Input } from 'antd'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

class Lesson extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      initialItems: [],
      data: [],
      modal: false,
      modalHeading: '',
      loading: true,
      confirmDeleteShow: false,
      deleteItemIndex: 0,
      model: { name: '' },
      pageSize: 0
    }

    this.getData()
  }

  handleModalCreate = () => {
    this.setState({
      modalHeading: 'ثبت درس جدید',
      modal: true,
      model: { name: '', codeMeli: '', mobile: '', address: '' }
    })
  }

  handleModalEdit = e => {
    let _model = this.state.data[e.target.dataset.index]
    // console.log(_model);

    this.setState({
      modal: true,
      model: _model,
      modalHeading: 'ویرایش درس "' + _model.name + '"'
    })
  }

  handleModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ modal: false })
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false })
  }

  getData() {
    lessonService
      .getAll()
      .then(res => {
        // console.log(res.data)
        var data = res.data
        var pageSize = data.length > 10 ? 10 : data.length
        this.setState({
          initialItems: data,
          pageSize: pageSize,
          data: data,
          loading: false,
          isSubmitting: false,
          modal: false
        })
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = e => {
    let _model = this.state.data[e.target.dataset.index]

    this.setState({ confirmDeleteShow: true, model: _model })
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false })

    lessonService
      .delete(this.state.model.id)
      .then(res => {
        toastr.success('حذف درس', 'درس با موفقیت حذف شد')
        this.getData()
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleSubmit = values => {
    this.setState({ loading: true })
    // console.log(values);

    if (values.id) {
      values['createDate'] = undefined

      // console.log(JSON.stringify(values));
      // var formData = convertToFormData(values)
      lessonService
        .edit(JSON.stringify(values))
        .then(res => {
          toastr.success(
            'ویرایش درس',
            'درس "' + values.name + '" با موفقیت ویرایش شد'
          )
          this.setState({ modal: false })
          this.getData()
        })
        .catch(error => {
          this.handleError(error)
        })
    } else {
      values['isActive'] = true
      // console.log(JSON.stringify(values));
      // var formData = convertToFormData(values)
      lessonService
        .add(JSON.stringify(values))
        .then(res => {
          toastr.success(
            'ثبت درس جدید',
            'درس "' + values.name + '" با موفقیت ثبت شد'
          )
          this.setState({ modal: false })
          this.getData()
        })
        .catch(error => {
          this.handleError(error)
        })
    }
  }

  render() {
    const ValidationSchema = Yup.object().shape({
      name: Yup.string()
        .trim()
        .required('نام درس')
      // price: Yup.string().trim().required('قیمت'),
      // email: Yup.string().trim().required('ایمیل'),
    })
    const { model, loading, data } = this.state
    return (
      !loading && (
        <div>
          <div className="row table-container" style={{ marginTop: 0 }}>
            <ReactTable
              data={data}
              filterable
              previousText="صفحه قبل"
              nextText="صفحه بعد"
              loadingText="در حال بارگذاری ..."
              noDataText="نتیجه ای یافت نشد"
              pageText="صفحه"
              ofText="از"
              rowsText="تعداد نمایش"
              getTableProps={() => ({ style: { display: 'block' } })}
              defaultFilterMethod={(filter, row) =>
                String(row[filter.id]) === filter.value
              }
              columns={[
                {
                  Header: 'ردیف',
                  id: 'row',
                  maxWidth: 50,
                  filterable: false,
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  className: 'numberFa',
                  Cell: row => {
                    return row.index + 1
                  }
                },
                {
                  Header: 'نام درس',
                  accessor: 'name',
                  id: 'name',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ['name'] }),
                  filterAll: true,
                  Filter: ({ onChange }) => (
                    <Input
                      placeholder=""
                      allowClear
                      onChange={event => onChange(event.target.value)}
                    />
                  )
                },
                // {
                //   Header: "قیمت",
                //   accessor: "price",
                //   id: "price",
                //   style: { display: 'flex', alignItems: 'center', 'justifyContent': 'center' },
                //   filterMethod: (filter, rows) =>
                //     matchSorter(rows, filter.value, { keys: ["price"] }),
                //   filterAll: true,
                //   Filter: ({ onChange }) =>
                //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
                // },
                {
                  Header: 'ویرایش',
                  accessor: 'id',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  sortable: false,
                  // filterable: false,
                  Filter: ({ filter, onChange }) => (
                    <a
                      onClick={this.handleModalCreate}
                      className="btn btn-primary react-table-add-btn">
                      <i className="mdi mdi-plus" />
                      افزودن درس جدید
                    </a>
                  ),
                  Cell: row => (
                    <div>
                      <a
                        onClick={this.handleModalEdit}
                        data-index={row.index}
                        className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn"
                        rel="tooltip"
                        data-original-title="ویرایش">
                        <i data-index={row.index} className="mdi mdi-pencil" />
                      </a>

                      <a
                        onClick={this.handleDelete}
                        data-index={row.index}
                        className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn"
                        data-original-title="حذف"
                        rel="tooltip">
                        <i data-index={row.index} className="mdi mdi-delete" />
                      </a>
                    </div>
                  )
                }
              ]}
              key={this.state.pageSize}
              defaultPageSize={this.state.pageSize}
              className="-striped -highlight"
            />
          </div>
          <Modal
            open={this.state.modal}
            onClose={this.handleModalHide}
            center
            classNames={{
              overlay: 'customOverlay',
              modal: 'customModal md',
              closeButton: 'customModalCloseButton'
            }}>
            <Formik
              initialValues={model}
              onSubmit={(values, { setSubmitting }) => {
                // console.log(values);
                this.handleSubmit(values)
              }}
              validationSchema={ValidationSchema}>
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit
                } = props
                return (
                  <div className="row" style={{ position: 'relative' }}>
                    <div className="col-md-12">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="form-inline">
                            <div className="col-md-12">
                              <label className="pull-right">نام درس</label>
                              <Field
                                type="text"
                                autoFocus
                                name="name"
                                className={
                                  getIn(errors, 'name') &&
                                  getIn(touched, 'name')
                                    ? 'text-input has-error rtl'
                                    : 'text-input required rtl'
                                }
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="name"
                              />
                            </div>

                            {/* <div className="col-md-6">
                            <label className="pull-right">قیمت</label>
                            <PriceInput
                              name="price"
                              value={values.price}
                              onChange={val => [
                                setFieldValue("price", val)
                              ]}
                              className={
                                getIn(errors, "price") &&
                                  getIn(touched, "price")
                                  ? "text-input has-error rtl"
                                  : "text-input required rtl"
                              }
                            />
                            <ErrorMessage component={ErrorPopUp} name="price" />
                          </div> */}

                            <div className="col-md-12">
                              <br />
                              <input
                                type="hidden"
                                name="id"
                                value={values.id}
                              />
                              <button
                                type="submit"
                                className={
                                  'icon button submit-btn ' +
                                  (isSubmitting ? 'isSubmitting' : '')
                                }
                                disabled={isSubmitting}>
                                ذخیره
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )
              }}
            </Formik>
          </Modal>

          <MySweetAlert
            show={this.state.confirmDeleteShow}
            onCancel={this.handleSweetAlertHide}
            onConfirm={this.handleConfirmDelete}
            title={
              'آیا از حذف درس [' + this.state.model.name + '] مطمئن هستید؟'
            }
          />
          {this.state.loading ? <Loading /> : ''}
        </div>
      )
    )
  }
}

export default Lesson
